export default "__VITE_ASSET__cI7SbmZh__"